module.exports = __webpack_public_path__ + "assets/img/36_1445.fae7ceb1.jpg";